import { disable, enable } from './action'
import { ignoredLocations } from './ignoredLocations'
import { location } from './location'
import { locations } from './locations'
import { setToUnprocessed } from './setToUnprocessed'
import { toggleHide } from './toggleHide'
import { toggleIgnoreLocation } from './toggleIgnoreLocation'
import { toggleShowDefaultProfile } from './toggleShowDefaultProfile'
import { getVehicle, searchRawVehicles } from './vehicles'

export const carsforsaleImportApi = {
  searchRawVehicles,
  getVehicle,
  location,
  locations,
  enable,
  disable,
  toggleHide,
  setToUnprocessed,
  ignoredLocations,
  toggleIgnoreLocation,
  toggleShowDefaultProfile,
}
